import validateGameOtpConfig from '../../../shares/lib/validateGameOtpConfig';
import OTPService from '../../../entities/playForRealGame/OTPService';
import { getSDKConfig } from '../../../shares/lib/getSDKConfig';

export async function getOTP() {
  const swipeSDKConfig = getSDKConfig();

  const isValid = validateGameOtpConfig(swipeSDKConfig.otpConfig);

  if (!isValid) {
    throw new Error('OTP Config not valid');
  }

  const otpService = new OTPService(swipeSDKConfig.otpConfig);
  const responseOTP = await otpService.getOTP();

  if (!responseOTP) {
    throw new Error('OTP Not Found');
  }

  return responseOTP;
}
